module.exports = __webpack_public_path__ + "static/media/checkbox_check.bb59dd9d.svg";